import { useEffect, useState } from "react";
import { useIntl } from "react-intl";

import { getAllGisLayers } from "services/requests/v1/gislayer";

import { GisLayerTableType } from "types/generic";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLayerGroup as LayerIconSolid } from "@fortawesome/free-solid-svg-icons";
import { faLayerGroup as LayerIconOutline } from "@fortawesome/pro-light-svg-icons";

import {
    GoMapLoader,
    GOMap,
    GOLayer,
    GOVectorLayer,
    GO_CONFIG,
} from "@goaigua/go-gisapi";

import {
    getEnvVariable,
    REACT_APP_GATEWAY_URL,
    REACT_APP_GISAPI_TOKEN,
} from "utils/environment";

import { setLayerOnMap } from "utils/functions";
import {
    configMap,
    setPointerOnMapMove,
    toggleTocActive,
    updateMapTheme,
} from "utils/gisMapFunctions";

import { useGisLayersTreeContext } from "storage/context/gis-layers-tree-hierarchy-context";
import { useThemeSelector } from "redux/reducers/global/hooks/use-theme-selector";

const token = getEnvVariable(REACT_APP_GISAPI_TOKEN);
const gatewayUrl = getEnvVariable(REACT_APP_GATEWAY_URL);

const GisHierarchyMap = () => {
    const [goMap, setGoMap] = useState<GOMap | null>(null);
    const [layers, setLayers] = useState<GisLayerTableType[]>([]);
    const [tocIsOpen, setTocIsOpen] = useState(false);

    const intl = useIntl();
    const theme = useThemeSelector();

    const {
        gisHierarchySelectedObject,
        gisHierarchySelected,
        setGisHierarchySelectedObject,
    } = useGisLayersTreeContext();

    useEffect(() => {
        const loadMap = async (layers: GisLayerTableType[]) => {
            const center = goMap?.getCenter("marker") as [number, number];

            GoMapLoader.AddToken(token);

            const GoMapAux = await GoMapLoader.loadGoMap(
                configMap(
                    layers,
                    intl,
                    theme
                ),
                gatewayUrl,
                GO_CONFIG.REGION_ENVIROMENTS.EUROPE
            );

            const mainMap = GoMapAux.getStaging("marker");
            if (!mainMap) return;

            center && GoMapAux?.setCenter("marker", center);
            updateMapTheme(mainMap, theme);
            setGoMap(GoMapAux);
        };

        getAllGisLayers().then((res) => {
            loadMap(res.data);
            setLayers(res.data);
        });
    }, []);

    useEffect(() => {
        const mainMap = goMap?.getMap("marker");
        if (goMap && goMap.getLayers) {
            goMap.getLayers("marker").forEach((layer: GOLayer) => {
                if (layer instanceof GOVectorLayer) {
                    layer.addFilter(
                        "BBOX(geom, -20037508, -20037508, 20037508, 20037508)",
                        false
                    );
                }
            });
        }
        if (mainMap) {
            mainMap?.on("pointermove", (evt: any) =>
                setPointerOnMapMove(mainMap, evt)
            );
        }
    }, [goMap]);

    useEffect(() => {
        let layerAux: GisLayerTableType[] = [];
        gisHierarchySelected.map((layer) => {
            if (layer && layer.object && layer.itemType === "layer") {
                layerAux.push(layer.object);
            }
        });

        setGisHierarchySelectedObject(layerAux);
    }, [gisHierarchySelected]);

    useEffect(() => {
        if (goMap && gisHierarchySelectedObject !== undefined) {
            setLayerOnMap(goMap, gisHierarchySelectedObject, layers);
        }
    }, [gisHierarchySelectedObject, goMap, layers]);

    useEffect(() => {
        const mainMap = goMap?.getStaging("marker");
        if (!mainMap) return;

        updateMapTheme(mainMap, theme);
    }, [theme, goMap]);

    return (
        <>
            <div className={"c-gis-hierarchy-map"}>
                <div className="c-gis-hierarchy-map__title">
                    {intl.formatMessage({ id: "app.gis.map_preview" })}
                </div>
                <div className={"c-gis-hierarchy-map__body"}>
                    <div className={"c-gis-hierarchy-map__body-map"} id="mapa">
                        <div
                            id="btn-toc"
                            onClick={() => toggleTocActive(setTocIsOpen)}
                        >
                            <FontAwesomeIcon
                                icon={
                                    tocIsOpen
                                        ? LayerIconSolid
                                        : LayerIconOutline
                                }
                            />
                        </div>

                        <div id="toc-container"></div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default GisHierarchyMap;
